module.exports = __webpack_public_path__ + "static/img/login-bg.d47b867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg.png
// module id = QPNa
// module chunks = 1